import { render, staticRenderFns } from "./DisplayOrEdit.vue?vue&type=template&id=3d1e4026&"
import script from "./DisplayOrEdit.vue?vue&type=script&lang=js&"
export * from "./DisplayOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports